// Progression PILOTÉE PAR LE MODÈLE — quel élément est affiché, pas quel bouton a été cliqué.
//
// ⚠️ LE DÉFAUT CORRIGÉ. La complétion n'était posée qu'à UN endroit : le `onPress` de la ligne
// de timeline (`navigateToItem(item); if (isAvailable) markComplete(item)`). Tout autre chemin
// menant au même élément — les flèches « ← / → » du bandeau, un lien profond de notification,
// le retour arrière du navigateur — l'ouvrait sans rien enregistrer. Le joueur pouvait donc
// traverser un chapitre entier par la navigation et voir sa progression rester à 1/12.
//
// La règle est désormais unique et attachée à l'ÉTAT AFFICHÉ : « cet écran montre l'élément X
// de la mission M » suffit à l'enregistrer. Aucun appelant n'a plus à y penser, et il n'y a
// plus deux chemins à tenir d'accord.
//
// ⚠️ CE N'EST PAS UN EFFET « AU MONTAGE ». Un écran de fiches reste monté pendant qu'on
// change de fiche, et chaque fiche est un élément de séquence à part entière : c'est le
// changement d'IDENTIFIANT qui compte, pas le cycle de vie du composant.
import { useEffect, useRef } from 'react';

import { useStoryProgress } from '../context/StoryProgressContext';

/**
 * Enregistre l'élément actuellement AFFICHÉ comme parcouru.
 *
 * @param missionId mission porteuse ; sans elle on n'enregistre rien (rien à rattacher).
 * @param itemId    identifiant de séquence de l'élément affiché (`el-123`).
 * @param active     `false` suspend l'enregistrement — élément verrouillé, contenu absent, ou
 *                  écran encore en chargement. Marquer « vu » un écran qui n'a rien montré
 *                  ferait progresser une mission que le joueur n'a pas lue.
 */
export function useElementVisited(
  missionId: number | undefined,
  itemId: string | number | undefined | null,
  active = true,
): void {
  const { completeItem } = useStoryProgress();
  // Mémoire LOCALE des identifiants déjà envoyés : `completeItem` est déjà idempotent côté
  // état, mais sans ce garde un re-rendu relancerait un appel réseau à chaque frame.
  const sent = useRef<Set<string>>(new Set());

  useEffect(() => {
    if (!active) return;
    if (missionId == null) return;
    const key = itemId == null ? '' : String(itemId);
    if (!key) return;
    if (sent.current.has(key)) return;
    sent.current.add(key);
    void completeItem(missionId, key);
  }, [missionId, itemId, active, completeItem]);
}
